<script setup lang="ts">
import SectionStepView from '../../views/SectionStepView/SectionStepView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
</script>

<template>
  <BPage>
    <div class="col fit q-mt-sm">
      <!-- Remount when the step OR its user-step changes: the engine reads the
           user-step id once (a replaced user-step must load fresh). -->
      <SectionStepView
        :key="`${$route.params?.stepDocId}:${$route.params?.userStepId}`"
      />
    </div>
  </BPage>
</template>
